import { useIntl } from "gatsby-plugin-intl"
import Banner from "../images/mockup_banner-min.png"
import { isAndroid, isIOS } from "react-device-detect"
import React, { useState, Fragment } from "react"
import { Row, Col, Button } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlay } from "@fortawesome/free-solid-svg-icons"
import ModalVideo from "react-modal-video"
import "../../node_modules/react-modal-video/scss/modal-video.scss"

const BannerSection = ({ siteTitle }) => {
  const intl = useIntl()
  const locale = intl.locale !== "id" ? `/${intl.locale}` : ""
  const [isOpen, setOpen] = useState(false)

  return (
    <Fragment>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="06V5x4HVznM"
        onClose={() => setOpen(false)}
      />
      <Row className={"mb-5"}>
        <Col lg={6}>
          <h1>{intl.formatMessage({ id: "promotion" })} </h1>
          <p>{intl.formatMessage({ id: "sub-promotion" })}</p>
          {isAndroid ? (
            <a href="https://play.google.com/store/apps/details?id=com.ngebis.ngebis_customer">
              <Button
                className={
                  "btn-primary btn-shadow-primary rounded-pill mt-4 px-4 mr-3"
                }
                style={{ fontWeight: "bold" }}
              >
                {intl.formatMessage({ id: "btn-download" })}
              </Button>
            </a>
          ) : isIOS ? (
            <a href="https://apps.apple.com/app/id1537058834">
              <Button
                className={
                  "btn-primary btn-shadow-primary rounded-pill mt-4 px-4 mr-3"
                }
                style={{ fontWeight: "bold" }}
              >
                {intl.formatMessage({ id: "btn-download" })}
              </Button>
            </a>
          ) : (
            <a href={`${locale}/download`}>
              <Button
                className={
                  "btn-primary btn-shadow-primary rounded-pill mt-4 px-4 mr-3"
                }
                style={{ fontWeight: "bold" }}
              >
                {intl.formatMessage({ id: "btn-download" })}
              </Button>
            </a>
          )}
          <Button
            className={"btn-primary-outline rounded-circle mt-4"}
            style={{ fontWeight: "bold" }}
            onClick={() => setOpen(true)}
          >
            <FontAwesomeIcon icon={faPlay} color={"#AD1457"} />
          </Button>
          {/* </a> */}
        </Col>
        <Col lg={6}>
          <img alt={"ngebis-mock"} src={Banner} className={"height-100"} />
        </Col>
      </Row>
    </Fragment>
  )
}

BannerSection.propTypes = {}

BannerSection.defaultProps = {
  siteTitle: ``,
}

export default BannerSection
